var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "wholesale-cart-item" },
    [
      _c(
        "td",
        { attrs: { "data-col": "title" } },
        [
          _c("product-title-component", {
            attrs: {
              productName: _vm.cartItem.title_scientific,
              productId: _vm.cartItem.id,
              plantId: _vm.cartItem.plant_id,
              isOnSale: _vm.isOnSale
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.columns, function(column, i) {
        return _c("td", { key: i, attrs: { "data-col": column } }, [
          _vm._v("\n        " + _vm._s(_vm.columnMap[column]) + "\n    ")
        ])
      }),
      _vm._v(" "),
      _c(
        "td",
        { attrs: { "data-col": "quantity" } },
        [
          _c("product-quantity-component", {
            attrs: {
              productId: _vm.cartItem.id,
              plantId: _vm.cartItem.plant_id,
              inventory: _vm.cartItem.inventory
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "text-left text-md-right",
          attrs: { "data-col": "total" }
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm._f("currency")(_vm.itemTotal)) + "\n    "
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }